/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import { useEffect, useState } from "react";
import { Field, Form } from 'formik';
import { Button, CircularProgress, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select } from '@mui/material';
import { TextField } from 'formik-mui';
import { BsFillEyeFill, BsFillEyeSlashFill } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';

import { getAllGetchkdUsers } from '../../../../../../store/reducers/getchkdUser/getchkdUserAction';


const CreateUserSecretForm = ({ values, handleBlur, handleChange, errors, touched, handleClose, isSubmitting }) => {
    const [showPassword, setShowPassword] = useState(false)
    const dispatch = useDispatch();
    const getchkdUsers = useSelector(state => state.getchkdUser.getchkdUsers);

    useEffect(() => {
        const fetchData = async () => {
            try {
                dispatch(getAllGetchkdUsers()).unwrap();

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, [dispatch]);



    return (

        <>
            <Form>

                <Grid container spacing={4}><Grid item xs={12} md={12} sm={12}>

                    {values.hasOwnProperty("getchkdid") &&
                        <FormControl fullWidth error={Boolean(touched.getchkdid && errors.getchkdid)}>
                            <InputLabel htmlFor="outlined-status">Getchkd User</InputLabel>
                            <Select
                                value={values.getchkdid}
                                variant="outlined"
                                name="getchkdid"
                                label="Getchkd User"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                style={{ color: 'white' }}
                            >
                                {getchkdUsers?.Records?.length > 0 && getchkdUsers?.Records?.map((item) => (
                                    <MenuItem value={item.getChkdID}>
                                        {item.email}
                                    </MenuItem>
                                ))}


                            </Select>
                            {errors.getchkdid && <FormHelperText style={{ color: "red" }} >{errors.getchkdid}</FormHelperText>}

                        </FormControl>
                    }
                    {values.hasOwnProperty("userName") &&
                        <FormControl fullWidth >

                            <Field
                                name="userName"
                                label="User Name"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.userName}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl>
                    }

                    {values.hasOwnProperty("userPass") &&
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl fullWidth error={Boolean(touched.userPass && errors.userPass)}>

                                    <Field
                                        name="userPass"
                                        label="Password"
                                        type={showPassword ? "text" : 'password'}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        value={values.userPass}
                                        component={TextField}
                                        InputProps={{

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                    >
                                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <FormControl fullWidth error={Boolean(touched.confirmPassword && errors.confirmPassword)}>

                                    <Field
                                        value={values.confirmPassword}
                                        component={TextField}

                                        name="confirmPassword"
                                        label="Confirm Password"
                                        type={showPassword ? "text" : 'password'}
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        margin="normal"
                                        variant="outlined"
                                        fullWidth
                                        InputProps={{

                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => { setShowPassword(!showPassword) }}
                                                    >
                                                        {showPassword ? <BsFillEyeFill /> : <BsFillEyeSlashFill />}
                                                    </IconButton>
                                                </InputAdornment>
                                            )
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                    }
                    {values.hasOwnProperty("appName") &&
                        <FormControl fullWidth >

                            <Field
                                name="appName"
                                label="Application Name"
                                type="text"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                value={values.appName}
                                margin="normal"
                                variant="outlined"
                                fullWidth
                                component={TextField}
                            />
                        </FormControl>
                    }
                </Grid>
                    <Grid item xs={12} md={12} sm={12}>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            style={{ marginTop: '20px' }}
                            disabled={isSubmitting}>
                            {isSubmitting &&
                                <CircularProgress size={24} color='success' style={{ marginLeft: '10px' }} />} Save
                        </Button>
                        <Button variant="outlined" onClick={() => handleClose()} style={{ marginTop: '20px', marginLeft: '10px' }}>close</Button>

                    </Grid>

                </Grid>
            </Form>
        </>
    )

}
export default CreateUserSecretForm;